import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CalendarBlank, X } from '@phosphor-icons/react';
import Cards from './components/Cards';
import DashboardCharts from './components/DashboardCharts';
import TopAgencies from './components/TopAgencies';
import RecentMessages from './components/RecentMessages';

function DateRangeFilter({ value, onChange }) {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const handleApply = () => {
    if (!from || !to) return;
    onChange({ from, to, key: Date.now() });
  };

  const handleClear = () => {
    setFrom('');
    setTo('');
    onChange(null);
  };

  const inputClass =
    'text-sm border border-neutral-300 rounded px-2.5 py-1.5 bg-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 focus-visible:border-brand-600 transition-colors';

  return (
    <div className="flex items-center gap-3 flex-wrap bg-white border border-neutral-200 rounded-md px-4 py-3">
      <CalendarBlank size={16} className="text-neutral-500 flex-shrink-0" />
      <span className="text-sm font-medium text-neutral-600 flex-shrink-0">
        Date Range
      </span>
      <div className="flex items-center gap-2 flex-wrap">
        <input
          type="date"
          value={from}
          max={to || undefined}
          onChange={(e) => setFrom(e.target.value)}
          className={inputClass}
        />
        <span className="text-neutral-400 text-sm">—</span>
        <input
          type="date"
          value={to}
          min={from || undefined}
          onChange={(e) => setTo(e.target.value)}
          className={inputClass}
        />
      </div>
      <button
        type="button"
        onClick={handleApply}
        disabled={!from || !to}
        className="h-8 px-3 rounded text-sm font-medium bg-brand-600 text-white hover:bg-brand-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"
      >
        Apply
      </button>
      {value && (
        <button
          type="button"
          onClick={handleClear}
          className="h-8 w-8 inline-flex items-center justify-center rounded text-neutral-500 hover:bg-neutral-100 hover:text-neutral-900 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-600"
          aria-label="Clear date filter"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}

DateRangeFilter.defaultProps = {
  value: null,
};

DateRangeFilter.propTypes = {
  value: PropTypes.instanceOf(Object),
  onChange: PropTypes.func.isRequired,
};

function Dashboard() {
  const [globalFilter, setGlobalFilter] = useState(null);

  return (
    <div className="space-y-8">
      <Cards />
      <DateRangeFilter value={globalFilter} onChange={setGlobalFilter} />
      <DashboardCharts globalFilter={globalFilter} />
      <TopAgencies />
      <RecentMessages />
    </div>
  );
}

export default Dashboard;
